import { Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-nexpe-search-bar',
  imports: [TranslateModule],
  templateUrl: './nexpe-search-bar.component.html',
  styleUrl: './nexpe-search-bar.component.scss',
})
export class NexpeSearchBarComponent {
  searchQuery = input<string>('');
  searchChange = output<string>();

  onSearchInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchChange.emit(input.value);
  }
}
